import PropTypes from 'prop-types';

import FormFieldWrapper from '@plone/volto/components/manage/Widgets/FormFieldWrapper';
import { sanitize } from '@designsystem/utils/sanitize';

const StaticTextWidget = (props) => {
  const { id, value } = props;

  return (
    <FormFieldWrapper {...props} className="text" columns={1}>
      <div id={id} className="wrapper">
        {/* START CUSTOMIZATION */}
        {/* A <div>, not a <p>: the editor text is block-level HTML (<h4>, <p>).
            Inside a <p> the browser closes the paragraph before the first
            block element, so the DOM parsed from the SSR markup differs from
            the client render and React abandons hydration of the whole page
            (#1756 — visible since the form block is server-rendered). */}
        <div
          dangerouslySetInnerHTML={{
            __html: sanitize(value?.data),
          }}
        />
        {/* END CUSTOMIZATION */}
      </div>
    </FormFieldWrapper>
  );
};

export default StaticTextWidget;

StaticTextWidget.propTypes = {
  id: PropTypes.string.isRequired,
  /* START CUSTOMIZATION */
  value: PropTypes.object,
  /* END CUSTOMIZATION */
  minLength: PropTypes.number,
  maxLength: PropTypes.number,
};

StaticTextWidget.defaultProps = {
  value: null,
  minLength: null,
  maxLength: null,
};
